
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3>{`Que disent les épidémiologistes?`}</h3>
    <p><strong parentName="p">{`L'avantage du `}<em parentName="strong">{`digital contact tracing`}</em></strong>{`, également appelé `}<em parentName="p">{`proximity
tracing`}</em>{`, est que les contacts peuvent être identifiés et mis en quarantaine
d'une façon beaucoup plus rapide.`}</p>
    <p><strong parentName="p">{`Le `}<em parentName="strong">{`contact tracing`}</em>{` classique`}</strong>{`, effectué par des spécialistes des autorités
sanitaires et des hôpitaux, qui tentent de remonter tous les contacts en
demandant avec diligence, `}<strong parentName="p">{`reste importante`}</strong>{` – surtout pour ceux qui
n'utilisent pas l'application. Mais cette façon de procéder est coûteuse et
lente: en général, on perd des heures, voire des jours jusqu'à ce que tous les
contacts puissent être trouvés et informés.`}</p>
    <p>{`Des experts de l'Université d'Oxford ont montré dans un
`}<a parentName="p" {...{
        "href": "https://science.sciencemag.org/content/early/2020/04/09/science.abb6936"
      }}>{`article`}</a>{`
de la revue «Science» l'`}<strong parentName="p">{`importance cruciale de la vitesse`}</strong>{` pour isoler les
personnes atteintes du Covid-19 et mettre en quarantaine les contacts.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;